import React from "react";

import { embedUrl } from "../Player/Helper";
import Section from "../../../components/Section";

import style from "./style.module.css";

export default function EmbeddedPlayer ({youtube_vimeo_link = ""}) {
    let url = "";
    if (youtube_vimeo_link !== "") {
        url = embedUrl(youtube_vimeo_link);
    }
    return (
        <>
        {
            url !== "" && (
                <Section className={style.embeddedPlayer}>
                    <div className={style.embeddedPlayerWrap}>
                        <iframe src={url} frameBorder='0' allowFullScreen title='WW2HQ Player' />
                    </div>
                </Section>
            )
        }
        </>
    )
}